import React from 'react';
export function Footer() {
  return <footer className="bg-carbon text-cream py-10 px-4 text-center border-t-4 border-brand-green" data-id="element-111">
      <div className="max-w-4xl mx-auto" data-id="element-112">
        <h2 className="text-2xl font-bold font-serif mb-4" data-id="element-113">
          🍪 BIBLIOTECADIGITAL.ONLINE™
        </h2>

        <p className="text-cream-dark mb-2 font-medium" data-id="element-114">
          El sistema de cocina y emprendimiento N°1 para familias y
          emprendedores en Argentina.
        </p>
        <p className="text-carbon-lighter mb-8 italic" data-id="element-115">
          Porque tener un negocio desde tu cocina no debería costarte todos los
          findesemana del año.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 mb-12 text-sm text-cream-dark" data-id="element-116">
          <a href="mailto:soportebibliodigital@gmail.com" className="hover:text-brand-green transition-colors" data-id="element-117">
            📧 soportebibliodigital@gmail.com
          </a>
          <span className="hidden md:inline text-carbon-lighter" data-id="element-118">|</span>
          <a href="#" className="hover:text-brand-green transition-colors" data-id="element-119">
            🌐 www.digitalbibliotec.online
          </a>
        </div>

        <div className="text-xs text-carbon-lighter border-t border-carbon-light pt-8" data-id="element-120">
          <p className="mb-4" data-id="element-121">
            © BibliotecaDigital.online™ 2024 — Todos los derechos reservados.
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
          <p className="font-serif italic text-cream-dark/50" data-id="element-122">
            🍪 "La cocina que ya sabés hacer puede ser el negocio que siempre
            quisiste tener."
          </p>
        </div>
      </div>
    </footer>;
}